"use client";
import React from "react";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const HallOfFameListLoader = ({
    children,
    hallOfFame,
}: {
    children?: React.ReactNode;
    hallOfFame: any;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved ? ( children ) : (
        <section>
            <img alt="hall of fame desktop" />
            <img alt="hall of fame mobile" />
            {hallOfFame.title}<br />
            {hallOfFame.des1}<br />
            {hallOfFame.des2}<br />
            {hallOfFame.models.map((model: any, index: number) => (
                <React.Fragment key={index}>
                    {model.title}<br />
                    {model.previewDes}<br />
                    {model.name}<br />
                    <img alt={model.imagePreviewAlt} /><br />
                </React.Fragment>
            ))}
        </section>
    );
}

export default HallOfFameListLoader;